import update from 'immutability-helper';

const initialState = {
  dialog: {
    isOpen: false
  },
  bar: {},
  barEnabled: true,
};

const initialDialog = Object.assign({}, initialState.dialog);

export function alerts(state = initialState, action) {
  switch (action.type) {
  case 'ALERT_DIALOG_OPEN':
    return Object.assign({}, state, {dialog: Object.assign({}, state.dialog, action.payload, {isOpen: true})});
  case 'ALERT_DIALOG_CLOSE':
    return Object.assign({}, state, {dialog: initialDialog});
  case 'ALERT_BAR_SHOW': {
    return update(state, {
      bar: {$set: action.payload}
    });
  }
  case 'ALERT_BAR_HIDE':
    return Object.assign({}, state, {bar: {}});
  case 'ALERT_BAR_DISABLE': {
    return update(state, {
      barEnabled: {$set: false}
    });
  }
  default:
    return state;
  }
}
